/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Container} from '@chakra-ui/react'
import {Region, regionPropType} from '@salesforce/commerce-sdk-react/components'

/**
 * This layout component displays GiftGuide component
 *
 * @param {componentProps} props
 * @param {regionType []} props.regions - The page designer regions for this component.
 * @returns {React.ReactElement} - GiftGuide component.
 */
export const GiftGuide = ({regions}) => {
    return (
        <Container my="2.125rem">
            <Flex justifyContent={'center'} columns={{base: '0', sm: '2', md: '5'}}>
                {regions.map((region) => (
                    <Region key={region.id} region={region} />
                ))}
            </Flex>
        </Container>
    )
}

GiftGuide.displayName = 'GiftGuide'

GiftGuide.propTypes = {
    // Internally Provided
    regions: PropTypes.arrayOf(regionPropType).isRequired
}

export default GiftGuide
